import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CalendarDeadline: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 2.5C5.5 1.94771 5.05228 1.5 4.5 1.5C3.94772 1.5 3.5 1.94771 3.5 2.5V3.5H3C2.17157 3.5 1.5 4.17157 1.5 5V13C1.5 13.8284 2.17157 14.5 3 14.5H13C13.8284 14.5 14.5 13.8284 14.5 13V5C14.5 4.17157 13.8284 3.5 13 3.5H12.5V2.5C12.5 1.94771 12.0523 1.5 11.5 1.5C10.9477 1.5 10.5 1.94771 10.5 2.5V3.5H5.5V2.5ZM10.25 7.25731C10.25 7.46726 10.1844 7.67196 10.0624 7.8428L9.05723 9.25L10.0624 10.6572C10.1844 10.828 10.25 11.0327 10.25 11.2427C10.25 11.799 9.79901 12.25 9.24269 12.25H6.75731C6.20099 12.25 5.75 11.799 5.75 11.2427C5.75 11.0327 5.8156 10.828 5.93763 10.6572L6.94277 9.25L5.93763 7.8428C5.8156 7.67196 5.75 7.46726 5.75 7.25731C5.75 6.70099 6.20099 6.25 6.75731 6.25H9.24269C9.79901 6.25 10.25 6.70099 10.25 7.25731Z"
      fill="currentColor"
    />
  </svg>
);
